<template>
  <div>
    <abstractTable :columns="reservationsColumns" :data="computedReservations"
                   :classes="'ui tablet stackable very compact center aligned very basic celled table'"
                   :dataPerPage="10" :paginationEnable="true"
                   style="padding-top: 20px" :paginationNextButtonText="$t('next')"
                   :paginationFirstPageButtonText="$t('first')"
                   :paginationLastPageButtonText="$t('last')"
                   :paginationPervButtonText="$t('previous')" v-if="computedReservations.length">

      <template slot="table-column">
        <th> {{ $t('actions') }} </th>
      </template>

      <template slot="table-row-after" slot-scope="props">
        <td style="width: 8%">
          <div class="ui blue very compact mini button" style="background-color: #092442"
                @click="props.row.id.functionality()">
            {{ $t('show') }}
          </div>
        </td>
      </template>
    </abstractTable>

    <div class="ui placeholder segment" style="margin-bottom: 50px" v-else>
      <div class="ui icon header" style="color: #092442">
        <i class="dont icon"></i>
        {{ $t('noReservationsHaveBeenAddedYet') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    doctor: { type: Object, required: true }
  },
  computed: {
    computedReservations () {
      let formlatedReservations = []

      window._.each(this.doctor.reservations, reservation => {
        let patient = reservation.patient
        let issuer = reservation.user
        formlatedReservations.push({
          id: {
            functionality: () => {
              this.navigateTo('Show_Reservation', {
                key: 'params',
                value: {
                  id: reservation.id,
                  clinic_id: reservation.clinic_id
                }
              })
            },
            value: `<a style="cursor: pointer; text-decoration:underline;">${reservation.id}</a>`
          },
          patient_mobile: patient.cell_phone,
          patient_name: {
            functionality: () => {
              this.navigateTo('Show_Patient', { key: 'params', value: { id: patient.id } })
            },
            value: `<a style="cursor: pointer;">${this.adjustName(patient.name)}</a>`,
            filteredValue: this.adjustName(patient.name)
          },
          issuer_name: {
            value: issuer.name,
            filteredValue: issuer.name
          }
        })
      })

      return formlatedReservations
    },
    reservationsColumns () {
      return [
        { header: this.$t('id'), fieldName: 'id', show: true, html: true },
        {
          header: this.$t('issuedBy'),
          fieldName: 'issuer_name',
          show: true,
          html: this.$auth.check('doctor'),
          filterable: true
        },
        {
          header: this.$t('patientName'),
          fieldName: 'patient_name',
          show: true,
          html: true,
          filterable: true
        },
        { header: this.$t('patientMobile'), fieldName: 'patient_mobile', show: true, filterable: false }
      ]
    }
  },
  methods: {
    getIssuer (issuerId) {
      return window._.find(this.doctor.issuers, issuer => {
        return issuer.id === issuerId
      })
    },
    getPatient (patientId) {
      return window._.find(this.doctor.patients, patient => {
        return patient.id === patientId
      })
    }

  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/doctors/doctor_components/ReservationsPart.vue